module.exports = __webpack_public_path__ + "static/media/head_img.93b81b8d.jpg";


//////////////////
// WEBPACK FOOTER
// /src/images/head_img.jpg
// module id = 742
// module chunks = 0